import type { OrderStatus } from '@/types/enums'
import { STATUS_BADGE_ACCENT_TEXT_HEX } from '@/utils/statusColors'

/**
 * Цвета маркеров и легенды карты — **отдельно** от `StatusBadge` (там акцент/ muted).
 * Логика: холодные оттенки → дорога → осмотр → сделка/деньги → логистика.
 * Значения согласованы с токенами темы (`theme.css`: carlink, orange, gold, semantic).
 */
const MAP_MARKER_HEX: Record<
  | 'SEARCH'
  | 'ASSIGNED'
  | 'DRIVING'
  | 'ARRIVED'
  | 'INSPECTION'
  | 'APPRAISAL'
  | 'BUYING'
  | 'DOCUMENT_PREPARATION'
  | 'PAYMENT_TRANSFER'
  | 'TRANSPORTATION',
  string
> = {
  SEARCH: '#38bdf8',
  ASSIGNED: '#6366f1',
  DRIVING: '#3b82f6',
  ARRIVED: '#06b6d4',
  INSPECTION: '#00b5ad',
  APPRAISAL: '#a855f7',
  BUYING: '#f7931a',
  DOCUMENT_PREPARATION: '#eab308',
  PAYMENT_TRANSFER: '#22c55e',
  TRANSPORTATION: '#818cf8',
}

/** Заливка SVG-маркера и кружка в легенде. */
export function mapOrderStatusMarkerFillHex(status: OrderStatus): string {
  const h = MAP_MARKER_HEX[status as keyof typeof MAP_MARKER_HEX]
  return h ?? STATUS_BADGE_ACCENT_TEXT_HEX
}

/** Фон бейджа статуса в HTML-балуне Яндекса: лёгкая заливка того же оттенка. */
export function mapStatusBalloonBadgeStyle(hex: string): { background: string; color: string } {
  const bg = hexToRgba(hex, 0.22)
  return { background: bg, color: hex }
}

function hexToRgba(hex: string, alpha: number): string {
  const n = hex.replace('#', '')
  if (n.length !== 6) return `rgba(247,147,26,${alpha})`
  const r = parseInt(n.slice(0, 2), 16)
  const g = parseInt(n.slice(2, 4), 16)
  const b = parseInt(n.slice(4, 6), 16)
  return `rgba(${r},${g},${b},${alpha})`
}
